import React, { useMemo } from 'react';

import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';

import FunctionalityItem, { IFunctionality } from './FunctionalityItem';

import * as ST from './styled';

interface IProps {
    items: IFunctionality[],
    className?: string,
    isLaptop: boolean,
    isDesktop: boolean,
}

const Functionalities: React.FC<IProps> = ({ items = [], className = '', isLaptop, isDesktop }): JSX.Element => {

    const mobileItems = useMemo(() => {
        return items.map((item: IFunctionality) => {
            const newItem = { ...item };
            newItem.image = newItem.image.replace(/([0-9]+)\.([a-zA-Z]+)/, '$1-sm.$2');
            newItem.image_webp = newItem.image_webp.replace(/([0-9]+)\.([a-zA-Z]+)/, '$1-sm.$2');

            return newItem;
        });
    }, [items]);

    const renderItems = useMemo(() => {
        return isLaptop ? mobileItems : items;
    }, [isLaptop, items, mobileItems]);

    return (
        <ST.Wrapper className={className}>
            <AdaptiveNukaCarousel
                desktopSlideWidth={
                    isLaptop
                        ? '327'
                            : isDesktop
                            ? '391'
                        : '479'
                }
                withoutArrows
                withoutDots={!isLaptop}
                cellSpacing={isDesktop ? 32 : 24}
                slidesToScroll={'auto'}
                heightMode='max'
                data-test='functionalities-carousel'
            >
                {
                    renderItems.map((item) => {
                        return <FunctionalityItem key={item.id} item={item}  data-test='functionality-item'/>;
                    })
                }
            </AdaptiveNukaCarousel>
        </ST.Wrapper>
    );
};

export default Functionalities;
